import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {requestSaveCddNeedFuNote} from "@app/services/CddNeedFuService";

const CddNeedFuEditModal = (props) => {
    const [cddNeedFu, setCddNeedFu] = useState({});
    const {data, isShow, onClose} = props

    useEffect(() => {
        setCddNeedFu({...data})
    },[data])

    const onSaveNeedFu = async () => {
        const requestBody = {
            candidate_id: cddNeedFu.candidate_id,
            cdd_rec_id: cddNeedFu.cdd_rec_id,
            cdd_need_fu_note: cddNeedFu,
        }

        const res = await requestSaveCddNeedFuNote(requestBody)
        if (res.sts_code === ResponseCode.SUCCESS) {
            onClose(true)
        } else {
            toast.error(res.message);
            alert(res.message)
        }
    }

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>{'Update thoong tin Cdd need fu'}</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{overflowY: 'auto', maxHeight: '70vh'}}>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}>Note</label>
                        <div style={{width: '100%'}}>
                        <textarea className='form-control'
                                  value={cddNeedFu.note || ''}
                                  name={'note'}
                                  onChange={event => {
                                      cddNeedFu.note = event.target.value
                                      setCddNeedFu({...cddNeedFu})
                                  }}/>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type='button'
                            className='btn btn-primary'
                            onClick={() => onSaveNeedFu()}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CddNeedFuEditModal;
